<div class="d-flex flex-wrap">
    <div class="mr-3 mb-3">
            <input [(ngModel)]="filterText"
            name="filterText"
            (keyup.enter)="refresh()"
            (blur)="refresh()"
            autoFocus
            class="form-control m-input"
            [placeholder]="l('SearchNameWithThreeDot')"
            type="text">
    </div>
    <div class="select-material-align">
        <div class="mr-3 mb-3">
        
        
            <div style="opacity: 0; pointer-events: none; height: 0px; width: 1px">
                <mat-form-field>
                    <mat-select [formControl]="locationFormCtrl" [multiple]="false" #locationSelector>
                        <mat-option>
                            <ngx-mat-select-search noEntriesFoundLabel="No results found"
                                placeholderLabel="Find a location..." [formControl]="locationFilterFormCtrl">
                            </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let location of filteredLocation | async" [value]="location" (click)="refresh()"
                            #option>
                            {{ location.materialName }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="mr-3 mb-3">
            <button class="btn btn-default btn-inverted" (click)="supplierSelector.open()">
                {{ l("Supplier") }}
            </button>
    
            <div style="opacity: 0; pointer-events: none; height: 0px; width: 1px">
                <mat-form-field>
                    <mat-select [formControl]="supplierFormCtrl" [multiple]="false" #supplierSelector>
                        <mat-option>
                            <ngx-mat-select-search noEntriesFoundLabel="No results found" placeholderLabel="Find a supplier..."
                                [formControl]="supplierFilterFormCtrl">
                            </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let supplier of filteredSupplier | async" [value]="supplier" (click)="refresh()" #option>
                            {{ supplier.supplierName }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="mr-3 mb-3">
            <button class="btn btn-link link-grey" (click)="clear()">
                {{ l("Clear") }}
            </button>
        </div>
    </div>
    
</div>
<div class="d-flex flex-wrap filter" *ngIf='filterText 
    || (locationFormCtrl.value && locationFormCtrl.value.locationName) || 
    (supplierFormCtrl.value && supplierFormCtrl.value.supplierName)'>
    {{ l("Filter") }}: 
    <span class="filter ml-3">
        <ng-container *ngIf='filterText'> {{ l("Search") }} - {{filterText}},</ng-container>
        <ng-container *ngIf='locationFormCtrl.value && locationFormCtrl.value.locationName'> {{ l("Location") }} - {{locationFormCtrl.value.locationName}},</ng-container>
        <ng-container *ngIf='supplierFormCtrl.value && supplierFormCtrl.value.supplierName'> {{ l("Vendor") }} - {{supplierFormCtrl.value.supplierName}},</ng-container>
    </span>
</div>